import {ACCIDENT_PARTIES_AT_FAULT_OPTIONS, ACCIDENT_TYPE_OPTIONS, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";

export default function PolicyHolderAccidentForm(
    {
        accident,
        driverIndex,
        accidentIndex,
        motorAccidentsListPropName,
        handlePolicyHolderAccidentPropChange ,
        addPolicyHolderAccident ,
        removePolicyHolderAccident,
    }
) {

    const generateName = (prop) => {
        return `${motorAccidentsListPropName}[${accidentIndex}][${prop}]`;
    }

    const generateIdPrefix = (prop) => {
        return `${motorAccidentsListPropName}-${accidentIndex}-${prop}-`;
    }

    return (
        <div className="policy-holder-accident-block hidden-box row">

            <DynamicItemHeadingComponent
                text="Accident"
                itemIndex={accidentIndex + 1}
                onRemoveIconClick={(e) => removePolicyHolderAccident(accidentIndex)}
            />

            {/*<ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Was a valid insurance policy in force at the time of accident?"
                required={true}
                controlName={generateName('hadActiveInsurance')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={accident.hadActiveInsurance}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'hadActiveInsurance', e.target.value)}
                btnGroupAttrs={{
                    className: 'btn-group vertical-mobile'
                }}
            />*/}

            {/* What type of incident was it? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="What type of incident was it?"
                required={true}
                controlName={generateName('type')}
                options={ACCIDENT_TYPE_OPTIONS}
                selectedValues={accident.type}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'type', e.target.value)}
                btnGroupAttrs={{
                    className: 'btn-group vertical-mobile'
                }}
            />


            {/* Date */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Date"
                required={true}
                controlName={generateName('date')}
                value={accident.date}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'date', e.target.value)}
            />

            {/* Approximate time of the incident (24hr time) */}

            {/*<ScrollableTextBoxBlock
                type="text"
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Approximate time of the incident (24hr time)"
                required={true}
                controlName={generateName('time')}
                value={accident.time}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'time', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />*/}

            {/* Who is at fault? */}

            <ScrollableDropdownBlock
                controlName={generateName('partyAtFault')}
                containerCssClass="col-6 py-3 "
                labelText="Who is at fault?"
                required={true}
                options={ACCIDENT_PARTIES_AT_FAULT_OPTIONS}
                selectedValues={accident.partyAtFault}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'partyAtFault', e.target.value)}
                helpText=""
            />

            {/* Location of Accident */}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Location of Accident"
                required={true}
                controlName={generateName('location')}
                value={accident.location}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'location', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />*/}

            {/* Brief Description of the Accident */}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Brief Description of the Accident"
                required={true}
                controlName={generateName('description')}
                value={accident.description}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'description', e.target.value)}
                inputAttrs={{
                    maxLength: 50,
                    rows : 3
                }}
                asTextArea={true}
            />*/}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Weather Condition"
                required={true}
                controlName={generateName('weatherCondition')}
                value={accident.weatherCondition}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'weatherCondition', e.target.value)}
                inputAttrs={{
                    maxLength: 50,
                    rows: 3
                }}
                asTextArea={true}
            />*/}

            {/* Cost */}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Cost"
                required={true}
                controlName={generateName('cost')}
                value={accident.cost}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'cost', e.target.value)}
                inputAttrs={{
                    maxLength: 10
                }}
            />*/}

            {/* Any Witness? */}

            {/*<ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Any Witness?"
                required={true}
                controlName={generateName('hadWitness')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={accident.hadWitness}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'hadWitness', e.target.value)}
            />*/}


            {/* Any Injuries? */}

            {/*<ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Any Injuries?"
                required={true}
                controlName={generateName('hadInjuries')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={accident.hadInjuries}
                onChange={(e) => handlePolicyHolderAccidentPropChange(accidentIndex, 'hadInjuries', e.target.value)}
            />*/}

        </div>
    );

}